<div class="user-configuration-group-main" data-cy="configuration-usergroup-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="configuration-usergroup-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="configuration-usergroup-header">
      <div class="section-header-title" data-cy="configuration-usergroup-title">
        Add user groups
      </div>
      <div style="flex: 1;"></div>
    </div>
    <app-tdo-progress-spinner style="flex: 1;" *ngIf="isLoading" data-cy="configuration-usergroup-spinner"></app-tdo-progress-spinner>
    <!--  MAIN AREA-->
    <div *ngIf="!isLoading" class="section-content" style="flex: 1; overflow-y: auto;" data-cy="configuration-usergroup-content">
      <div *ngFor="let group of groups" data-cy="configuration-usergroup-item">
        <mat-checkbox [checked]="isUserInGroups(group)" (change)="onCheckboxChange($event, group)" data-cy="configuration-usergroup-checkbox">{{group.UserGroupName}}</mat-checkbox>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;" data-cy="configuration-usergroup-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onOkClick()" class="tdo-button primary-accent" style="margin-right: 6px;" data-cy="configuration-usergroup-ok-button">Ok</button>
      <button (click)="onCancelClick()" class="tdo-button primary-accent" style="margin-right: 6px;" data-cy="configuration-usergroup-cancel-button">Cancel</button>
    </div>
  </div>
</div>
